module.exports = __webpack_public_path__ + "static/media/Group 9964.d013ddb8.svg";